<template lang="html">

  <section class="front-page">
    <v-content>
      <v-row class="mt-0 mb-n10 mb-md-0 mb-lg-0 mb-xl-0 pt-0 pb-0">
        <searchbar :type="'genre'" :cols="12" :sm="12" :md="12" :lg="12" :xl="12"></searchbar>
        <v-col class="pt-5 mt-1" :class="{'pr-1 pl-1': $vuetify.breakpoint.smAndDown}" cols="4" :sm="4" :md="2" :lg="2" :xl="2">
          <v-menu
              v-model="genreFilter"
              :close-on-content-click="false"
              :nudge-width="500"
              offset-y
          >
            <template v-slot:activator="{ on }">
              <v-btn
                  text
                  color="white"
                  dark
                  v-on="on"
                  class="filter-button"
              >
                Genres
              </v-btn>
            </template>
            <v-card color="accent">
              <v-container>
                <v-select :items="filterGenres"
                          v-model="selectedGenres"
                          clearable
                          item-text="name"
                          item-value="id"
                          label="Genre"
                          multiple
                          chips
                          @change="applyFilter"
                          class="filter_select"
                          :menu-props="{  offsetY: true }"
                ></v-select>
              </v-container>
            </v-card>
          </v-menu>
        </v-col>
        <v-col class="pt-5 mt-1" :class="{'pr-1 pl-1': $vuetify.breakpoint.smAndDown}" cols="4" :sm="4" :md="2" :lg="2" :xl="2">
          <v-menu
              v-model="publisherFilter"
              :close-on-content-click="false"
              :nudge-width="500"
              offset-y
          >
            <template v-slot:activator="{ on }">
              <v-btn
                  text
                  color="white"
                  dark
                  v-on="on"
                  class="filter-button"
              >
                Publishers
              </v-btn>
            </template>
            <v-card color="accent">
              <v-container>
                <v-select
                    :items="publishers"
                    v-model="selectedPublishers"
                    clearable
                    label="Publisher"
                    item-text="name"
                    item-value="id"
                    @change="applyFilter"
                    :menu-props="{ offsetY: true }"
                ></v-select>
              </v-container>
            </v-card>
          </v-menu>
        </v-col>
        <v-col class="pt-5 mt-1" :class="{'pr-1 pl-1': $vuetify.breakpoint.smAndDown}" cols="4" :sm="4" :md="2" :lg="2" :xl="2">
          <v-menu
              v-model="playerCountFilter"
              :close-on-content-click="false"
              :nudge-width="200"
              offset-y
          >
            <template v-slot:activator="{ on }">
              <v-btn
                  text
                  color="white"
                  dark
                  v-on="on"
                  class="filter-button"
              >
                Players
              </v-btn>
            </template>
            <v-card color="accent">
              <v-container>
                <v-range-slider
                    v-model="playerCount"
                    max="20"
                    min="0"
                    hide-details
                    class="align-center"
                    @change="applyFilter"
                >
                  <template v-slot:prepend>
                    <v-text-field
                        :value="playerCount[0]"
                        class="mt-0 pt-0 centered-input"
                        hide-details
                        single-line
                        filled
                        dense
                        type="number"
                        style="width: 55px;"
                        @change="$set(playerCount, 0, $event); applyFilter()"
                    ></v-text-field>
                  </template>
                  <template v-slot:append>
                    <v-text-field
                        :value="playerCount[1]"
                        class="mt-0 pt-0 centered-input"
                        hide-details
                        single-line
                        filled
                        dense
                        type="number"
                        style="width: 55px"
                        @change="$set(playerCount, 1, $event); applyFilter()"
                    ></v-text-field>
                  </template>
                </v-range-slider>
              </v-container>
            </v-card>
          </v-menu>
        </v-col>
        <v-col class="pt-5 mt-1" :class="{'pr-1 pl-1': $vuetify.breakpoint.smAndDown}" cols="4" :sm="4" :md="2" :lg="2" :xl="2">
          <v-menu
              v-model="playTimeFilter"
              :close-on-content-click="false"
              :nudge-width="200"
              offset-y
          >
            <template v-slot:activator="{ on }">
              <v-btn
                  text
                  color="white"
                  dark
                  v-on="on"
                  class="filter-button"
              >
                Playtime
              </v-btn>
            </template>
            <v-card color="accent">
              <v-container>
                <v-range-slider
                    v-model="playTime"
                    max="240"
                    min="0"
                    hide-details
                    class="align-center"
                    @change="applyFilter"
                >
                  <template v-slot:prepend>
                    <v-text-field
                        :value="playTime[0]"
                        class="mt-0 pt-0 centered-input"
                        hide-details
                        single-line
                        filled
                        dense
                        type="number"
                        style="width: 55px"
                        @change="$set(playTime, 0, $event); applyFilter()"
                    ></v-text-field>
                  </template>
                  <template v-slot:append>
                    <v-text-field
                        :value="playTime[1]"
                        class="mt-0 pt-0 centered-input"
                        hide-details
                        single-line
                        filled
                        dense
                        type="number"
                        style="width: 55px"
                        @change="$set(playTime, 1, $event); applyFilter()"
                    ></v-text-field>
                  </template>
                </v-range-slider>
              </v-container>
            </v-card>
          </v-menu>
        </v-col>
        <v-col class="pt-5 mt-1" :class="{'pr-1 pl-1': $vuetify.breakpoint.smAndDown}" cols="4" :sm="4" :md="2" :lg="2" :xl="2">
          <v-menu
              v-model="ageFilter"
              :close-on-content-click="false"
              :nudge-width="200"
              offset-y
          >
            <template v-slot:activator="{ on }">
              <v-btn
                  text
                  color="white"
                  dark
                  v-on="on"
                  class="filter-button"
              >
                Age
              </v-btn>
            </template>
            <v-card color="accent">
              <v-container>
                <v-range-slider
                    v-model="age"
                    max="99"
                    min="0"
                    hide-details
                    class="align-center"
                    @change="applyFilter"
                >
                  <template v-slot:prepend>
                    <v-text-field
                        :value="age[0]"
                        class="mt-0 pt-0 centered-input"
                        hide-details
                        single-line
                        filled
                        dense
                        type="number"
                        style="width: 55px"
                        @change="$set(age, 0, $event); applyFilter()"
                    ></v-text-field>
                  </template>
                  <template v-slot:append>
                    <v-text-field
                        :value="age[1]"
                        class="mt-0 pt-0 centered-input"
                        hide-details
                        single-line
                        filled
                        dense
                        type="number"
                        style="width: 55px"
                        @change="$set(age, 1, $event); applyFilter()"
                    ></v-text-field>
                  </template>
                </v-range-slider>
              </v-container>
            </v-card>
          </v-menu>
        </v-col>
        <v-col class="pt-5 mt-1" :class="{'pr-1 pl-1': $vuetify.breakpoint.smAndDown}" cols="4" :sm="4" :md="2" :lg="2" :xl="2">
          <v-menu
              v-model="ratingFilter"
              :close-on-content-click="false"
              :nudge-width="200"
              offset-y
          >
            <template v-slot:activator="{ on }">
              <v-btn
                  text
                  color="white"
                  dark
                  v-on="on"
                  class="filter-button"
              >
                Rating
              </v-btn>
            </template>
            <v-card color="accent">
              <v-container>
                <v-slider
                    v-model="rating"
                    class="align-center"
                    max="5"
                    min="0"
                    @change="applyFilter"
                >
                  <template v-slot:append>
                    <v-text-field
                        v-model="rating"
                        class="mt-0 pt-0 centered-input"
                        hide-details
                        single-line
                        filled
                        dense
                        type="number"
                        style="width: 45px"
                        @change="applyFilter"
                    ></v-text-field>
                  </template>
                </v-slider>
              </v-container>
            </v-card>
          </v-menu>
        </v-col>
<!--        <v-col class="pt-5 mt-1 " cols="2" :sm="2" :md="1" :lg="1" :xl="1">-->
<!--          <v-btn @click="resetFilter">-->
<!--            <v-icon>mdi-close</v-icon>-->
<!--          </v-btn>-->
<!--        </v-col>-->
      </v-row>
      <GameList :headlines="genres" :voteable="true" :show-rating="true" type="genre" :showMore="true"
                :url="recentUrl" :user="user" :class="{'mt-5': $vuetify.breakpoint.sm || $vuetify.breakpoint.xs, 'd-none': filterApplied}"></GameList>
      <GameCollection :voteable="true" :user="user" :type="filter"
                      :thumb_url="thumb_url" :showRating="true"
                      :profile_pic_url="profile_pic_url" :headline="'Your search'"
                      :games="filteredGames" :class="{'d-none': !filterApplied, 'mt-12': $vuetify.breakpoint.smAndDown}">

      </GameCollection>
    </v-content>
    <infinite-loading @infinite="infiniteHandler">
      <div slot="no-more" class="text--disabled">No more games :)</div>
    </infinite-loading>
  </section>

</template>

<script lang="js">
import GameList from "./GameList";
import GameService from "../../services/GameService";
import Searchbar from "./Searchbar";
import PublisherService from "../../services/PublisherService";
import InfiniteLoading from 'vue-infinite-loading';
import {getState} from "core-js/modules/web.url-search-params";
import GameCollection from "@/components/games/GameCollection.vue";
import axios from "axios";
import authHeader from "@/services/auth-header";
import GenreService from "@/services/GenreService";

export default {
  name:       'games-page',
  props:      ['user'],
  components: {
    GameCollection,
    Searchbar,
    GameList,
    InfiniteLoading
  },
  mounted () {
    this.url       = window.api_url + '/api/games/filter';
    this.recentUrl = window.api_url + '/api/auth/friends/recent';
    this.getPublishers();
    this.getGenres();
  },
  data () {
    return {
      'genres':             [],
      'filterGenres':       [],
      'url':                [],
      'recentUrl':          [],
      'selectedGenres':     [],
      'selectedPublishers': [],
      'publishers':         [],
      'playerCount':        [0, 20],
      'playTime':           [0, 240],
      'age':                [0, 99],
      'rating':             0,
      'filter':             false,
      'genreFilter':        false,
      'publisherFilter':    false,
      'playerCountFilter':  false,
      'playTimeFilter':     false,
      'ageFilter':          false,
      'ratingFilter':       false,
      'filterApplied':      false,
      'genreOffset':        0,
      'filteredGames':      [],
      'thumb_url':          window.api_url + "/storage/image/game/thumb_",
      'profile_pic_url':    window.api_url + "/storage/image/user/",
      'nextPageUrl':        ''
    }
  },
  watch:    {
    user: {
      handler () {
        this.url = window.api_url + '/api/games/filter';
      }
    },

  },
  methods:  {
    getState,
    getPublishers () {
      PublisherService.getPublishers()
                      .then(res => {
                        this.publishers = res.data;
                      })
                      .catch(err => {
                        console.log(err);
                      })
    },
    getGenres () {
      GenreService.getGenres()
                  .then(res => {
                    this.filterGenres = res.data;
                  })
                  .catch(err => {
                    console.log(err);
                  })
    },
    applyFilter () {
      GameService.filter(this.url, this.selectedGenres, this.selectedPublishers, this.playerCount, this.playTime, this.age, this.rating)
                 .then(res => {
                   console.log(res);
                   this.genres        = [];
                   this.filteredGames = [];
                   this.filteredGames = res.data.data;
                   this.filterApplied = true;
                   this.nextPageUrl   = res.data.next_page_url;
                 });
    },
    resetFilter () {
      this.selectedGenres     = [];
      this.selectedPublishers = [];
      this.playerCount        = [0, 20];
      this.playTime           = [0, 240];
      this.age                = [0, 99];
      this.rating             = 0;
      this.filterApplied      = false;
      this.applyFilter();
    },
    infiniteHandler ($state) {
      if (this.filterApplied && this.nextPageUrl && this.nextPageUrl !== '') {
        axios.post(this.nextPageUrl, {headers: authHeader()})
             .then(res => {
               let temp;
               this.nextPageUrl = res.data.next_page_url;
               temp             = res.data.data;
               temp.forEach(element => {
                 this.filteredGames.push(element);
               });

               if (res.data.data.length > 0) {
                 $state.loaded();
               } else {
                 $state.complete();
               }
             })
             .catch(err => console.log(err));
        return;
      }

      GameService.getGamesByGenre(this.genreOffset).then(res => {
        console.log(res);
        this.genres.loaded = true;
        res.data.data.forEach(element => {
          this.genres.push(element);
        });
        this.genreOffset = res.data.offset;
        console.log(this.genres);
        if (res.data.data.length <= 0) {
          $state.complete();
        } else {
          $state.loaded();
        }
      }).catch(err => console.log(err));
    }
  },
  computed: {},
}


</script>

<style lang="scss">
.front-page {

}

.filter_select {

}

/** Remove Number Input Arrows */
input[type='number'] {
  -moz-appearance: textfield;
}

input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button,
input[type='number']:hover::-webkit-inner-spin-button,
input[type='number']:hover::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.filter-button {
  width: 100%;
  background-color: var(--v-accent-base);
}

</style>

<style scoped>
.centered-input >>> input {
  text-align: center
}
</style>
